import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQuery } from 'react-query'
import { reportError } from 'utils/error'

export const useLastUsedLanguage = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()

  return useQuery<{ language: string | null }>(
    ['lastUsedLanguage', currentWorkspaceId],
    async () => {
      const res = await WorkspaceClient.getLastUsedLanguage(currentWorkspaceId)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error('Error fetching the last used language')
      }
      return res.data
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      onError: reportError,
    },
  )
}
